import {
  Alert, Box, Button, Grid, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
  useTheme,
} from '@mui/material';
import { Trash01, Plus } from '../../../assets';
import { useContext } from 'react';
import { ScheduleCreateContext, ScheduleCreateValues } from '../contexts/ScheduleCreateContext';


const ScheduleCreateCountZones = () => {
  const { t,
    isLoading,
    isCountZoneConfigEnabled,
    countZonesData,
    hasRightToEdit,
    deleteCountZoneRow,
    handleAddCountZonesClick,
    handleViewCountZoneItemsClick,
    schedules } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const theme = useTheme();
  const hasCountZones = countZonesData.length > 0;

  const allStoreNumbers = schedules.flatMap(s => s.storeNumbers || []);
  const uniqueStoreNumbers = Array.from(new Set(allStoreNumbers));

  if (isLoading || !isCountZoneConfigEnabled) {
    return <></>;
  }

  return (
    <Box sx={{ border: '2px solid', borderRadius: '4px', borderColor: theme.palette.primary[500] }}>
      <Grid container
        sx={{ pt: '12px', pb: '6px', px: '8px' }}>
        <Grid item
          xs={3}>
          <Typography variant="textMD"
            sx={{ fontWeight: 'bold' }}>{t('countZones.title')}</Typography>
        </Grid>
        <Grid item
          xs={9}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {hasCountZones && (
            <Button
              size='lg'
              sx={{ mr: 4 }}
              variant='bad'
              disabled={!hasRightToEdit}
              onClick={() => deleteCountZoneRow()}>
              <Trash01 />{t('deleteAll')}
            </Button>
          )}
          <Button
            size='lg'
            variant='primary'
            disabled={!hasRightToEdit || (uniqueStoreNumbers.length > 1)}
            onClick={handleAddCountZonesClick}><Plus />{t('add')}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ pt: '10px' }}>
        {hasCountZones ? (
          <TableContainer sx={{ overflowy: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('countZones.subtitle')}
                  </TableCell>
                  <TableCell
                    style={{ display: 'flex', justifyContent: 'flex-end' }} >{t('remove')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {countZonesData?.map((row) => (
                  <TableRow key={row.locationId}>
                    <TableCell
                      onClick={() => handleViewCountZoneItemsClick(row.locationId ?? 0)}
                      sx={{ cursor: 'pointer' }}>
                      <Typography
                        variant='textXS'
                        fontWeight={600}
                        color={theme.palette.primary[500]}
                        sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                        {row.name}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ display: 'flex', justifyContent: 'flex-end' }} >
                      <IconButton aria-label={t('countZones.deleteZone')}
                        disabled={!hasRightToEdit}
                        onClick={() => { deleteCountZoneRow(row.locationId); }}>
                        <Trash01 style={{ color: !hasRightToEdit ? 'action' : 'red' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity='info'
            variant='outlined'
            sx={{ mb: '12px', mx: '8px' }}>
            {t('countZones.noZones')}
          </Alert>
        )}
      </Box>
    </Box>
  );
};

export default ScheduleCreateCountZones;